export const columnsDataInvoices = [
  {
    Header: "System ID",
    accessor: "invoiceNumber",
  },
  {
    Header: "Invoice Number",
    accessor: "referenceNumber",
  },
  {
    Header: "Company Name",
    accessor: "userId",
  },
  {
    Header: "Debtor Name",
    accessor: "debtorName",
  },
  {
    Header: "USD Amount",
    accessor: "amount",
  },
  {
    Header: "Created On",
    accessor: "createdAt",
  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "Expected Due Date",
    accessor: "expectedDueDate",
  },
  {
    Header: "Actions",
    accessor: "actions",
  },
];
